export default __webpack_public_path__ + "static/Messaging CTA Callout Graphics 2 – 300x600px-858eac5b2065d2b568917cdb0868bd05.png";